import { render, staticRenderFns } from "./outpatient.vue?vue&type=template&id=a3d7040a&scoped=true"
import script from "./outpatient.vue?vue&type=script&lang=js"
export * from "./outpatient.vue?vue&type=script&lang=js"
import style0 from "./outpatient.vue?vue&type=style&index=0&id=a3d7040a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d7040a",
  null
  
)

export default component.exports